export default {
    devices_activate_simcard_title: "Activar la Tarjeta SIM de la Cámara",
    devices_activate_simcard_label: "Este proceso activará las tarjetas SIM de la cámara. ¿Desea continuar?",
    devices_activate_simcard_label_single: "Este proceso activará la tarjeta SIM de la cámara. ¿Desea continuar?",
    devices_activate_simcard_device_name: "Nombre del dispositivo",
    devices_activate_simcard_serial: "Serial",
    devices_activate_simcard_response: "Respuesta",
    devices_activate_simcard_yes: "Si",
}